import { StyleSheet } from 'react-native';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { designSystem } from '@/styles/styles';

import {
    LABEL_LINE_HEIGHT,
    LEAGUE_ITEM_GAP,
    LEAGUE_ITEM_LABEL_GAP,
    LEAGUE_ITEM_WIDTH,
    LEAGUE_NAVIGATOR_HEIGHT,
    LIST_PADDING_LEFT,
    LIST_PADDING_TOP,
} from '../utils/league-navigator-utils';

const SKELETON_COLOR = designSystem.colors.neutral300;
const ITEM_COUNT = 16;
const items = Array.from({ length: ITEM_COUNT }, (_, index) => index);

export const LeagueNavigatorSkeleton = () => (
    <MaxWidthWrapper>
        <Row style={styles.row}>
            {items.map(index => (
                <Box key={index} style={styles.item}>
                    <LoadingSkeleton
                        skeletonColor={SKELETON_COLOR}
                        width={LEAGUE_ITEM_WIDTH}
                        height={LEAGUE_ITEM_WIDTH}
                        borderRadius={'r12'}
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                    />
                    <LoadingSkeleton
                        skeletonColor={SKELETON_COLOR}
                        width={LEAGUE_ITEM_WIDTH}
                        height={LABEL_LINE_HEIGHT}
                        borderRadius={'r4'}
                    />
                </Box>
            ))}
        </Row>
    </MaxWidthWrapper>
);

const styles = StyleSheet.create({
    row: {
        height: LEAGUE_NAVIGATOR_HEIGHT,
        overflow: 'hidden',
        paddingLeft: LIST_PADDING_LEFT,
        paddingTop: LIST_PADDING_TOP,
        gap: LEAGUE_ITEM_GAP,
    },
    item: {
        alignItems: 'center',
        gap: LEAGUE_ITEM_LABEL_GAP,
    },
});
